import { ItemList } from '../orm'
import { ENTITY_KEY__UNREGISTERED_EVENT_FOLLOWER, LIST_KEY__UNREGISTERED_EVENT_FOLLOWER } from './ItemListKeyRegistry'

class UnregisteredEventFollowerList extends ItemList {
    getEntityKey() {
        return ENTITY_KEY__UNREGISTERED_EVENT_FOLLOWER
    }
}

export const unregisteredEventFollowerList = new UnregisteredEventFollowerList(LIST_KEY__UNREGISTERED_EVENT_FOLLOWER)